module.exports = __webpack_public_path__ + "static/walls_night_mobile-68d7710734ab480d54f02a6fad61ddf3.jpg";